import React, { type FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faXmark } from "@awesome.me/kit-70c1f0055f/icons/classic/light";
import { TASK_LIGHT_RED_HOVER } from "@/components/ui/task-steps-progress/taskProgressTokens";

export type TaskProgressControlMode = "stop" | "resume";

export interface TaskProgressControlProps {
  mode: TaskProgressControlMode;
  onClick: () => void;
  disabled?: boolean;
  testId?: string;
  title?: string;
}

/** Compact stop (×) / resume (▶) control for task progress bars. */
export const TaskProgressControl: FC<TaskProgressControlProps> = ({
  mode,
  onClick,
  disabled = false,
  testId = "task-progress-control",
  title,
}) => {
  const isStop = mode === "stop";
  const label = title ?? (isStop ? "Stop task" : "Resume task");

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      disabled={disabled}
      title={label}
      aria-label={label}
      data-testid={testId}
      className={[
        "flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-full transition-colors",
        disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer",
        isStop
          ? `text-slate-500/80 dark:text-slate-500 ${TASK_LIGHT_RED_HOVER}`
          : "text-slate-500/80 dark:text-slate-500 hover:text-indigo-600 dark:hover:text-indigo-400",
      ].join(" ")}
    >
      <FontAwesomeIcon icon={isStop ? faXmark : faPlay} className="text-[10px]" />
    </button>
  );
};
